import React from "react";

export const DynamicTable = ({ tableInfo }) => {
  console.log(tableInfo, "tableinfo");
  return (
    <div class="shadowclass mt-0">
      <div className="top-header-sec d-flex justify-content-between mb-0">
        <h4 className="event-alert mb-3 col-md-4">
          {tableInfo?.title}
          <div className="clear"></div>
        </h4>
        {tableInfo?.tableTabsInfo?.length > 0 && (
          <ul class="nav summary_filter col-md-4" id="pills-tab" role="tablist">
            {tableInfo?.tableTabsInfo?.map((el) => (
              <li class="nav-item" role="presentation">
                <a
                  onClick={() => el?.runOnClick()}
                  class={`nav-link ${el?.active ? "active" : ""}`}
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  {el?.name}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="row justify-content-between align-items-center w-100">
        <div className="col-md-4">
          {tableInfo?.showSearch && (
            <div className="search-box mt-0">
              <input type="text" placeholder="Search" name="keyword1" />
              <input type="submit" onclick="return false;"></input>
            </div>
          )}
        </div>
        {tableInfo?.showUpperAddButton && (
          <div class="col-md-2 align-right px-0">
            <div class="field text-right">
              <button
                onClick={() => {
                  tableInfo?.addOnClick();
                }}
                class="btn green-btn-revert add-plus addSp mx-0"
                id="addCount"
                type="button"
              >
                <i class="i-icon"> </i> {tableInfo?.addButtonTitle}
              </button>
            </div>
          </div>
        )}
      </div>

      <div class="inner-space screen-scroll mCS_destroyed">
        <table
          id="TableDable"
          class="checklist-table remove-space"
          cellspacing="0"
          cellpadding="0"
          width="100%"
        >
          <thead>
            <tr>
              {tableInfo?.headings?.map((heading) => (
                <th>{heading}</th>
              ))}
            </tr>
          </thead>
          <tbody id="bankingIndex">
            {tableInfo?.dataArray?.map((el) => {
              return (
                <tr>
                  {tableInfo?.dataKeys?.map((dataKey) => (
                    <td>{el[dataKey]}</td>
                  ))}
                  {tableInfo?.actions && (
                    <td>
                      {tableInfo?.editable && (
                        <p
                          onClick={() => {
                            tableInfo?.editOnClick(el[tableInfo?.editKey]);
                          }}
                          className="circle_icon"
                        >
                          <i class="iconSprites edit-icon"></i>{" "}
                        </p>
                      )}

                      {tableInfo?.deleteable && (
                        <p
                          class="circle_icon delete_tooltip red"
                          onClick={() => {
                            const deleteKeyValuePairs = {};
                            for (const element of tableInfo?.deleteKeyValuePairs) {
                              deleteKeyValuePairs[element?.key] =
                                el[element?.value];
                            }
                            tableInfo?.deleteOnClick(deleteKeyValuePairs);
                          }}
                        >
                          <i class="iconSprites delete-icon"></i>
                        </p>
                      )}
                      {tableInfo?.activable && (
                        <p
                          class={`circle_icon pwr_tooltip ${
                            el?.status === 1 ? "on" : ""
                          } `}
                          onClick={() => {
                            let activeKeyValuePairs = {};
                            for (const element of tableInfo?.activeKeyValuePairs) {
                              activeKeyValuePairs[element?.key] =
                                el[element?.value];
                            }
                            activeKeyValuePairs = {
                              ...activeKeyValuePairs,
                              status:
                                activeKeyValuePairs?.status === 1
                                  ? "inactive"
                                  : "active",
                            };
                            tableInfo?.activeOnClick(activeKeyValuePairs);
                          }}
                        >
                          <i class="iconSprites pwr-icon"></i>
                        </p>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>

        {tableInfo?.showLowerAddButton && (
          <div class="my-3">
            <p
              onClick={() => {
                tableInfo?.addOnClick();
              }}
              id="addBanking"
              class="btn green-btn-revert add-plus"
            >
              <i class="i-icon"> </i>
              {tableInfo?.addButtonTitle}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DynamicTable;
